import React, { useState } from "react"
import { CardBody, Card, Alert } from "reactstrap"

import { DataTable } from "components/DataTable"
import { Pagination } from "components/Pagination"
import { SearchBox } from "components/SearchBox"
import { useLocalPaginatedRequest } from "hooks/useLocalPaginatedRequest"
import {
   CommitDepartmentAuditItems,
   CommitWarehouseAuditItems,
   CountsheetItemDetails,
   CountsheetListing,
} from "api/api.service"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"
import { Button } from "components/Button"
import ConfirmationModal from "pages/Configurator/Trailers/ConfirmationModal"
import toast from "react-hot-toast"

const DATA_KEY = "data"
const TOTAL_KEY = "total"
const DOMAIN = {
   DEPARTMENT: "departmentName",
   WAREHOUSE: "warehouseName",
}
const COLUMNS = {
   DATE: "Date",
   TIME: "Time",
   WAREHOUSE: "Warehouse",
   STATION: "Station",
   ACTUAL_QUANTITY: "Actual Quantity",
   AUDIT_QUANTITY: "Audit Quantity",
   ACTION: "Action",
}

const ItemDetails = ({
   auditFor = "",
   itemsId = "",
   warehouseId = "",
   departmentId = "",
   name = "",
   subKey = "",
}) => {
   const {
      page,
      searchText,
      handleSearchChange,
      handlePageClick,
      pageSize,
      onChangePageSize,
      data,
      total,
      request,
      isFetching,
   } = useLocalPaginatedRequest({
      requestFn: CountsheetItemDetails,
      params: {
         ...(departmentId?.length && { departmentId: departmentId }),
         ...(warehouseId && { warehouseId: warehouseId }),
         auditCategory: auditFor,
         itemsId: itemsId,
      },
      deps: [],
      dataKey: DATA_KEY,
      totalKey: TOTAL_KEY,
   })
   const [modalState, setModalState] = useState(false)
   const [isLoading, setIsLoading] = useState(false)

   const handleCommit = async () => {
      setModalState(prev => !prev)
      const payload = {
         itemsIds: [data[0]?.itemsId],

         ...(departmentId?.length > 0 &&
            subKey === DOMAIN.DEPARTMENT && {
               departmentIds: departmentId?.map(id => id),
            }),

         ...(warehouseId &&
            subKey === DOMAIN.WAREHOUSE && {
               warehouseIds: [warehouseId],
            }),
      }

      try {
         setIsLoading(true)
         if (subKey === DOMAIN.WAREHOUSE) {
            await CommitWarehouseAuditItems(payload)
            toast.success(`Item has been committed successfully!`)
         } else if (subKey === DOMAIN.DEPARTMENT) {
            await CommitDepartmentAuditItems(payload)
            toast.success(`Item has been committed successfully!`)
         }
         request()
         handleCloseModal()
      } catch (error) {
         console.log(error)
      } finally {
         setIsLoading(false)
      }
   }
   const handleConfirmationModal = () => {
      setModalState(prev => !prev)
   }

   const handleCloseModal = () => {
      setModalState(false)
   }

   return (
      <>
         <div className="mb-5">
            <div className="d-flex justify-content-center">
               <h3>Item# {itemsId}</h3>
            </div>
            <div className="p-2 p-md-4 wh-im-wh-gi-con">
               <div className="mb-3">
                  <div className="d-flex align-items-center justify-content-between admin-inventory-management-general-inventory-responsiveness ">
                     <div className="ad-location-search-box">
                        <SearchBox
                           inputClasses="vendor-search-input input-search"
                           labelClass="d-none"
                           placeholder="Search"
                           searchIcon={true}
                           searchIconClass="vendor-table-search-icon"
                           conClass="vendor-table-search-inner-class"
                           searchText={searchText}
                           onChange={handleSearchChange}
                        />
                     </div>
                  </div>
               </div>
               <div className="data-table-item-container">
                  <DataTable
                     data={data}
                     tableClasses="ad-warehouse-general-inventory-table"
                     loading={isFetching}
                     config={[
                        {
                           title:
                              subKey === DOMAIN.WAREHOUSE
                                 ? COLUMNS.WAREHOUSE
                                 : COLUMNS.STATION,
                           render: data => data?.[name]?.[subKey],
                        },
                        {
                           title: COLUMNS.DATE,
                           render: data =>
                              convertDateTime({
                                 date: data.updatedAt,
                                 customFormat:
                                    dateTimeFormat.casitaCustomDateFormatOnly,
                                 dateOnly: true,
                              }),
                        },
                        {
                           title: COLUMNS.TIME,
                           render: data =>
                              convertDateTime({
                                 date: data.updatedAt,
                                 customFormat: dateTimeFormat.onlyTimeFormat,
                                 dateOnly: true,
                              }),
                        },
                        {
                           title: COLUMNS.ACTUAL_QUANTITY,
                           render: data => data.existingQuantity,
                        },
                        {
                           title: COLUMNS.AUDIT_QUANTITY,
                           render: data => data.auditQuantity,
                        },
                        {
                           title: COLUMNS.ACTION,
                           render: data => (
                              <Button
                                 disabled={
                                    !(!data?.isCommited && data?.canBeCommitted)
                                 }
                                 title={true ? "Commit" : "Committed"}
                                 type={"submit"}
                                 className="list-commit-button cursor-pointer"
                                 onClick={handleConfirmationModal}
                              />
                           ),
                        },
                     ]}
                  />
               </div>
               <Pagination
                  currentPage={page}
                  totalData={total}
                  onPageClick={handlePageClick}
                  rowLimit={pageSize}
                  onChangePageSize={onChangePageSize}
               />
            </div>
         </div>

         <ConfirmationModal
            isOpen={modalState}
            actionName="Save"
            entityName="Commit"
            toggleFunction={handleCloseModal}
            handleYes={handleCommit}
         />
      </>
   )
}

export default ItemDetails
